module.exports = "/images/collapse.svg?7703108b059eac38718b0db95e74429d";


//////////////////
// WEBPACK FOOTER
// ./resources/images/collapse.svg
// module id = ./resources/images/collapse.svg
// module chunks = 0